import { render, staticRenderFns } from "./GlobalScheme.vue?vue&type=template&id=c7cf8c92&scoped=true&"
import script from "./GlobalScheme.vue?vue&type=script&lang=ts&"
export * from "./GlobalScheme.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalScheme.vue?vue&type=style&index=0&id=c7cf8c92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cf8c92",
  null
  
)

export default component.exports